import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'filterable-input',
  templateUrl: './filterable-input.component.html',
  styleUrls: ['./filterable-input.component.css']
})
export class FilterableInputComponent implements OnInit {

  @Input('id') inputId: string = '';

  @Input('autocompleteValue') autoCompleteValue: any[] = [];
  @Input('disabledInput') inputDisabled: boolean = false;

  @Output('change') mOnInputChange: EventEmitter<any> = new EventEmitter<any>();
  @Output('keypress') mOnKeyPress = new EventEmitter<any>();
  @Output('focus') mOnFocus = new EventEmitter<any>();
  @Output('focusout') mOnFocusOut = new EventEmitter<any>();

  // Represente le ngModel le keyword peut pas etre utilisé [(ngModel)]="xxxx"
  @Input() inputModel!: string; // TODO: '!' operator sur le ngmodel
  @Output() inputModelChange = new EventEmitter<string>();

  readonly filteredAutoCompletedValue = new Subject<string[]>();

  constructor() { }

  ngOnInit(): void { }

  private async filter(value: any) {
    const filterValue = value.toString().toLowerCase();
    const newFilteredOption: any[] = this.autoCompleteValue.filter(option => option.toString().toLowerCase().startsWith(filterValue));
    // Bloquage de la taille max du tableau pour ne pas remplire la memoire
    if (newFilteredOption.length > 20)
      newFilteredOption.length = 20;
    this.filteredAutoCompletedValue.next(newFilteredOption);
  }

  onInputChange(event: any) {
    this.mOnInputChange.emit(event);
  }

  onInputFocus(event: FocusEvent) {
    if (event.target instanceof HTMLInputElement)
      this.filter(event.target.value);
    this.mOnFocus.emit(event);
  }

  onInputKeyUp(event: KeyboardEvent) {
    if (event.target instanceof HTMLInputElement)
      this.filter(event.target.value);
  }

  onInputKeyPress(event: KeyboardEvent) {
    this.mOnKeyPress.emit(event);
  }
}
